module.exports = __webpack_public_path__ + "img/gate_1_2.f5e199ee.png";